export default "__VITE_ASSET__CSXUsN3D__"